<template>
  <v-container>
    <v-dialog v-model="showDialog" max-width="1000">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-sm-4 text-capitalize light--text" v-on="on">
          <v-icon class="dark--text" @click="onShowPlanSwitch">mdi-nintendo-switch</v-icon>
          Switch Plan
        </v-btn>
      </template>

      <v-card class="pa-3 pa-md-12">
        <v-row>
          <v-col md7>
            <v-card-title class="text-h5 dark--text mt-n2">Switch Plan</v-card-title>
          </v-col>
          <v-col md3>
            <CustomerPlanSwitchHistory :subscription="subscribedPackage._id" />
          </v-col>
          <v-spacer></v-spacer>

          <v-btn color="dark" text @click="showDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row class="justify-end"> </v-row>

        <v-form class="pa-4 pa-sm-8 mt-n8" @submit="switchPlan()" v-model="valid" ref="form">
          <v-layout wrap>
            <v-flex xs12 sm12 class="pa-2">
              <v-card>
                <v-container>
                  <p class="text-center dark--text">From</p>
                  <v-divider class="mb-6 mt-n2"></v-divider>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Package</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      {{ subscribedPackage.package.titleEn }}
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Choice</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      {{ subscribedPackage.package.availableChoices[0].choiceNameEn }}
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Start Date</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      {{ new Date(parseInt(subscribedPackage.start_date)) | moment("MMM DD YYYY") }}
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">End Date</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      {{ new Date(parseInt(subscribedPackage.end_date)) | moment("MMM DD YYYY") }}
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Plan Days</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      {{ getPlanDays() }}
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Variant</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <PlanSwitchVariants :dayChoices="subscribedPackage.package.dayChoices" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12 sm12 class="pa-2">
              <v-card>
                <v-container>
                  <p class="text-center dark--text">To</p>
                  <v-divider class="mb-6 mt-n2"></v-divider>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Package</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <v-select
                        @change="toPackageChange"
                        v-model="packageTo"
                        :items="packagesList"
                        :rules="[requiredValidator('Package'), packageValidation]"
                        item-value="_id"
                        item-text="titleEn"
                        chips
                        label="Plan"
                        dense
                        attach
                        solo
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Choice</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                      <v-select
                        @change="toChoiceChange"
                        :items="toChoiceList.availableChoices"
                        :rules="[requiredValidator('Choice')]"
                        v-model="choiceTo"
                        item-text="choiceNameEn"
                        item-value="_id"
                        label="Choices"
                        dense
                        attach
                        solo
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm8 md2 class="mt-2 ml-2"> {{ toVariantList.availableNumOfDays }} days </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Variant</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <v-select
                        :items="toVariantList.mealChoice"
                        :rules="[requiredValidator('Variant')]"
                        v-model="variantTo"
                        item-text="variantNameEn"
                        item-value="_id"
                        dense
                        label="Variant"
                        attach
                        solo
                        @change="toVariantChange"
                      ></v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <label class="text-body-2 dark--text">Available Days</label>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <v-select
                        v-model="availableDays"
                        :items="listOfDays"
                        item-text="day"
                        item-value="day"
                        attach
                        dense
                        return-object
                        solo
                        chips
                        :rules="[requiredValidatorSelect('available days')]"
                        label="Available Days"
                        multiple
                        flat
                        outlined
                        :disabled="isAllowCustomerWeekDays()"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-4 mb-6"></v-divider>
                  <v-layout wrap>
                    <v-checkbox v-model="hasCustomizeDayChoice" label="Customize Plan choice"></v-checkbox>
                  </v-layout>

                  <v-layout wrap v-show="hasCustomizeDayChoice">
                    <v-flex xs12 sm8 md9>
                      <v-tabs class="mt-2" v-model="tab" center-active slider-color="primary">
                        <v-tab v-for="day in availableDays" :key="day.day" :value="day.day"
                          ><label class="text-caption text-sm-body-2 text-capitalize">{{ day.day }}</label></v-tab
                        >
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(day, index) in availableDays" :key="index">
                          <v-card color="pop_bg">
                            <span v-show="false">{{ index }}</span>
                            <v-flex xs8 sm6 class="text-body-2 dark--text ms-sm-5" v-for="(item, dayIndex) in day.allCategories" :key="item._id">
                              <!-- {{ item}} -->
                              {{ item.nameEn }}
                              <span v-show="false">{{ dayIndex }}</span>
                              <div>
                                <v-layout class="mt-2" wrap row justify-space-around>
                                  <v-flex xs4 sm6>
                                    <v-text-field :label="item.nameEn + '(No.)'" solo type="number" @keypress="isNumber" v-model="item.count" min="0" dense></v-text-field>
                                  </v-flex>
                                  <v-flex xs3 sm4 class="mt-1">
                                    <v-btn small color="primary " @click="applyToAll(item)">Apply to All</v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-flex>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Additional Days</h4>
                    </v-flex>
                    <!--  :rules="[sameNoOfDays]" -->
                    <v-flex xs12 sm8 md9>
                      <v-text-field v-model="additionalDays" attach solo :rules="positiveNoRule" @change="calculateTotalDays" dense type="number" min="0">
                        <template v-slot:append>
                          <h4 class="mt-1 grey--text">Days</h4>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Total Days</h4>
                    </v-flex>
                    <!--  :rules="[sameNoOfDays]" -->
                    <v-flex xs12 sm8 md9>
                      <v-text-field v-model="totalDays" attach solo readonly dense type="number" min="0">
                        <template v-slot:append>
                          <h4 class="mt-1 grey--text">Days</h4>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap class="mb-4">
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2"> Current Plan Price :</v-flex>

                    <v-flex xs12 sm8 md2 class="mt-n4 mt-sm-2">
                      <strong> {{ formatCurrency(subscribedPackage.package_price) }}</strong>
                    </v-flex>

                    <v-flex xs12 sm8 md2 class="mt-n4 mt-sm-2">New Plan Price : </v-flex>
                    <v-flex xs12 sm8 md2 class="mt-n4 mt-sm-2" v-if="toVariantDetails">
                      <strong>
                        {{ formatCurrency(toVariantDetails.price) }}
                      </strong>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Additional Price</h4>
                    </v-flex>
                    <!--  :rules="[sameNoOfDays]" -->
                    <v-flex xs12 sm8 md9>
                      <v-text-field v-model="additionalPrice" attach @change="reCalculateTotalPrice" solo dense :rules="positiveNoRule" type="number" min="0">
                        <template v-slot:append>
                          <h4 class="mt-1 grey--text">KWD</h4>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <h4 class="text-body-2 dark--text">Discount</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <v-text-field
                        v-model="discount"
                        label="Discount"
                        @keypress="isFloatNumber"
                        :rules="positiveNoRule"
                        @change="reCalculateTotalPrice"
                        solo
                        type="number"
                        min="0"
                        dense
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap v-if="showPaymentMethod" class="mb-2">
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <label class="text-body-2 dark--text">Payable Amount</label>
                    </v-flex>
                    <v-flex xs12 sm8 md9 class="mt-2">
                      <strong> {{ payableAmount }} KWD</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="showPaymentMethod">
                    <v-flex xs12 sm4 md3 class="mt-n4 mt-sm-2">
                      <label class="text-body-2 dark--text">Payment Method</label>
                    </v-flex>
                    <v-flex xs12 sm8 md9>
                      <v-select
                        solo
                        dense
                        :rules="[requiredValidatorSelect('payment method')]"
                        attach
                        @change="onPaymentMethodChange"
                        item-text="text"
                        item-value="value"
                        v-model="paymentMethod"
                        :items="avalilablePaymentMethod"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn color="primary" class="mb-2 mb-sm-4 light--text text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="switchPlan" :loading="btnloading" :disabled="!valid">
              Switch Plan
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackColor">{{ text }}</v-snackbar>
    </v-dialog>
  </v-container>
</template>
<script>
import PlanSwitchVariants from "./PlanSwitchVariants.vue";
import CustomerPlanSwitchHistory from "./CustomerPlanSwitchHistory.vue";
import { requiredValidator, requiredValidatorSelect } from "../../../core/methods/validations";
export default {
  components: { PlanSwitchVariants, CustomerPlanSwitchHistory },
  props: {
    subscribedPackage: {
      require: true,
    },
  },
  apollo: {
    getAllCategories() {
      return {
        query: require("@/menu-packages/api/getAllCategories.graphql"),
        variables: this.variables,
        result({ data }) {
          let allCategories = data.getAllCategories.category.filter(x => x.active == true);
          this.allCategories = JSON.parse(JSON.stringify(allCategories));
        },
      };
    },
  },
  methods: {
    isAllowCustomerWeekDays() {
      if (this.masterPackage) {
        if (this.masterPackage.allowedWeekDays) {
          if (this.masterPackage.allowedWeekDays.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    onPaymentMethodChange() {
      if (this.paymentMethod == "FREE") {
        this.payableAmount = 0;
      } else {
        this.reCalculateTotalPrice();
      }
    },
    onShowPlanSwitch() {
      this.showPaymentMethod = false;
      this.paymentMethod = null;
      this.currentDiscount = this.subscribedPackage.discount ? this.subscribedPackage.discount : 0;

      this.calculateTotalDays();
    },
    calculateTotalDays() {
      let planDays = this.getPlanDays();
      let additionalDays = this.additionalDays ? parseInt(this.additionalDays) : 0;

      let additionalExistingDays = this.subscribedPackage.package.availableChoices[0].additionalDays ? this.subscribedPackage.package.availableChoices[0].additionalDays : 0;

      let totalDays = parseInt(planDays) + additionalDays + additionalExistingDays;

      this.totalDays = totalDays;
    },
    reCalculateTotalPrice() {
      let additionalPackagePrice = this.additionalPrice ? parseFloat(this.additionalPrice) : 0;
      debugger;

      let discount = this.discount ? parseFloat(this.discount) : 0;

      let payableAmount = this.additionalPrice - discount + this.currentDiscount;

      this.payableAmount = payableAmount.toFixed(3);
      if (payableAmount > 0) {
        this.showPaymentMethod = true;
      } else {
        this.showPaymentMethod = false;
      }

      if (discount > payableAmount) {
        this.discount = 0;
      }

      if (this.paymentMethod == "FREE") {
        this.payableAmount = 0;
      }

      this.totalPrice = (this.subscribedPackage.net_price - discount + this.currentDiscount + additionalPackagePrice).toFixed(3);
    },
    packageCountListing() {
      // debugger;
      this.availableDays = [];
      if (this.toChoiceInfo && this.toChoiceInfo) {
        this.allCategories.forEach(element => {
          element.count = 0;
        });
        this.listOfDays = [];

        let sunday = {
          day: "Sunday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let monday = {
          day: "Monday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let tuesday = {
          day: "Tuesday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let wednesday = {
          day: "Wednesday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let thursday = {
          day: "Thursday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let friday = {
          day: "Friday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };
        let saturday = {
          day: "Saturday",
          allCategories: JSON.parse(JSON.stringify(this.allCategories)),
        };

        this.availableChoices = new Array();
        // let packageInfo = this.selectPackage;
        this.toChoiceInfo.availableDays.forEach(day => {
          switch (day) {
            case "Sunday": {
              sunday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(sunday);
              break;
            }
            case "Monday": {
              monday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(monday);
              break;
            }
            case "Tuesday": {
              tuesday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(tuesday);
              break;
            }
            case "Wednesday": {
              wednesday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(wednesday);
              break;
            }
            case "Thursday": {
              thursday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(thursday);
              break;
            }
            case "Friday": {
              friday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(friday);
              break;
            }
            case "Saturday": {
              saturday.allCategories.forEach(category => {
                let dayChoice = this.toVariantDetails.dayChoices.find(x => x.day == day);
                if (dayChoice) {
                  let dayCategory = dayChoice.mealCount.find(x => x.category._id == category._id);
                  if (dayCategory) {
                    category.count = dayCategory.count;
                  }
                }
              });
              this.availableDays.push(saturday);
              break;
            }
          }
        });
        this.listOfDays.push(sunday);
        this.listOfDays.push(monday);
        this.listOfDays.push(tuesday);
        this.listOfDays.push(wednesday);
        this.listOfDays.push(thursday);
        this.listOfDays.push(friday);
        this.listOfDays.push(saturday);
      }
    },
    getPlanDays() {
      let availableDays = this.subscribedPackage.package.availableChoices[0].availableNumOfDays;
      let additionalDays = this.subscribedPackage.package.availableChoices[0].additionalDays;
      if (additionalDays) {
        return availableDays - additionalDays;
      }
      return availableDays;
    },
    getVariant(id) {
      if (this.toVariantList) {
        let variant = this.toVariantList.mealChoice.find(x => x._id == id);
        if (variant) {
          this.toDayChoices = variant.dayChoices;
        }
      }
      this.packageCountListing();
      return null;
    },
    getAllPackages() {
      this.$apollo
        .watchQuery({
          query: require("@/menu-packages/api/getAllPackagesWithChoice.graphql"),
          variables: this.variables,
        })
        .refetch({})
        .then(data => {
          if (data.data) {
            this.packagesList = data.data.getAllPackages.packages.filter(x => x.active);
          }
        });
    },
    toPackageChange() {
      this.choiceTo = "";
      this.variantTo = "";
      this.toChoiceList = this.packagesList.find(x => x._id == this.packageTo);
      this.toPackageInfo = this.packagesList.find(x => x._id == this.packageTo);
      console.log(this.toPackageInfo);
      this.getPackageById();
    },
    toChoiceChange() {
      this.variantTo = "";
      this.toVariantList = this.toChoiceList.availableChoices.find(x => x._id == this.choiceTo);
      this.toChoiceInfo = this.toChoiceList.availableChoices.find(x => x._id == this.choiceTo);
    },
    toVariantChange() {
      this.toVariantDetails = this.toVariantList.mealChoice.find(x => x._id == this.variantTo);

      this.getVariant(this.variantTo);
    },
    packageValidation() {
      if (this.packageTo && this.subscribedPackage.package.packageId) {
        if (this.packageTo == this.subscribedPackage.package.packageId) {
          return "Same Package cant switch";
        }
        return true;
      }
      return true;
    },
    isFloatNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    applyToAll(category) {
      this.availableDays.forEach(day => {
        day.allCategories.forEach(element => {
          if (element._id == category._id) {
            element.count = category.count;
          }
        });
      });
      this.snackbar = true;
      this.snackColor = "success";

      this.text = "Meal count applied to all days.";
    },
    getPackageById() {
      this.$apollo
        .watchQuery({
          query: require("../../../menu-packages/api/getPackageAllowedWeekDays.graphql"),
          variables: {
            packageId: this.packageTo,
          },
        })
        .refetch({
          variables: {
            packageId: this.packageTo,
          },
        })
        .then(data => {
          this.masterPackage = data.data.getPackageById;
          this.packageCountListing();
        });
    },
    switchPlan() {
      //  let noOfDays = this.getPlanDays();
      // if (parseInt(this.toVariantList.availableNumOfDays) !== noOfDays) {
      //     this.text = "No of Days of Packages should be same";
      //     this.snackColor = "red";
      //     this.snackbar = true;
      //     return false;
      // }
      this.btnloading = true;
      let dayChoices = new Array();
      this.availableDays.forEach(dayChoice => {
        let mealCounts = new Array();
        dayChoice.allCategories.forEach(element => {
          if (parseInt(element.count) > 0) {
            let mealCount = {
              count: parseInt(element.count),
              category: element._id,
            };
            mealCounts.push(mealCount);
          }
        });
        let dayChoiceItem = {
          day: dayChoice.day,
          mealCount: mealCounts,
        };
        dayChoices.push(dayChoiceItem);
      });

      let customerPackage = {
        dayChoices: dayChoices,
      };
      let availableDays = this.availableDays.map(x => x.day);
      debugger;
      let switchPakage = {
        packageId: this.packageTo,
        choiceId: this.choiceTo,
        variantId: this.variantTo,
        subscribedPackageId: this.subscribedPackage._id,
        customerId: this.$route.query.customerId,
        paymentMethod: this.paymentMethod,
        additionalPrice: parseFloat(this.additionalPrice),
        additionalDays: parseInt(this.additionalDays),
        discount: parseFloat(this.discount),
        packageInfo: customerPackage,
        availableDays: availableDays,
      };

      this.$apollo
        .mutate({
          mutation: require("./api/switchCustomerPlan.graphql"),
          variables: {
            input: switchPakage,
          },
        })
        .then(() => {
          this.showDialog = false;
          this.text = "Plan switched successfully";
          this.snackColor = "success";
          this.snackbar = true;
          this.$root.$emit("updateGetCustomerById");
          this.$refs.form.reset();
          this.btnloading = false;
        })
        .catch(error => {
          this.btnloading = false;
          if (error.graphQLErrors != null) {
            this.text = error.graphQLErrors[0].message;
            this.snackbarColor = "error";
            this.snackbar = true;
          }

          console.log(error);
        });
    },
  },

  created() {
    this.getAllPackages();
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_ONLINE)) {
      const data = this.paymentMethods[0];
      this.avalilablePaymentMethod.push(data);
    }
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_OFFLINE)) {
      const data = this.paymentMethods[1];
      this.avalilablePaymentMethod.push(data);
    }
    if (this.hasRole(this.AdminUserPermissions.PAYMENT_FREE)) {
      const data = this.paymentMethods[2];
      this.avalilablePaymentMethod.push(data);
    }
  },
  data() {
    return {
      requiredValidator,
      hasCustomizeDayChoice: false,
      requiredValidatorSelect,
      availableDays: [],
      snackbar: false,
      toDayChoices: [],
      snackColor: "",
      text: "",
      btnloading: false,
      tab: "",
      showDialog: false,
      showPaymentMethod: false,
      valid: false,
      paymentMethod: null,
      packageTo: "",
      choiceTo: "",
      variantTo: "",
      packagesList: [],
      totalDays: "",
      toChoiceList: [],
      toVariantList: "",
      additionalDays: "",
      additionalPrice: "",
      toVariantDetails: null,
      avalilablePaymentMethod: [],
      currentDiscount: 0,
      payableAmount: 0,
      positiveNo: [v => v >= 0 || "Enter a valid discount"],
      positiveNoRule: [v => v >= 0 || "Value should not be less than 0"],
      discount: 0,
      listOfDays: [],
      variables: {
        limit: 0,
        skip: 0,
      },
      masterPackage: null,
      paymentMethods: [
        {
          value: "ONLINE",
          text: "Online",
        },
        {
          value: "OFFLINE",
          text: "Offline",
        },
        {
          value: "FREE",
          text: "Free",
        },
      ],
      allCategories: null,
    };
  },
};
</script>
